import { Block } from "@/components";
import { spacings } from "@/assets/themes";
import { getPaymentMethodBadge } from "./utils";
import { VISA_MASTERCARD, VISA, MASTERCARD } from "./constants";

const Methods = ({ methods, size = "35px", className }) => {
  const processedMethods = methods.flatMap((method) => {
    if (method === VISA_MASTERCARD) {
      return [VISA, MASTERCARD];
    }
    return [method];
  });

  return (
    <Block display="flex" gap={spacings.xxs} className={className}>
      {processedMethods.map((method) => (
        <Block key={method}>
          <img
            src={getPaymentMethodBadge(method)}
            alt={method}
            width={size}
            height="auto"
          />
        </Block>
      ))}
    </Block>
  );
};

export default Methods;
